import { cn } from '@app/utils/cn';
import React from 'react';

interface Props {
  className?: string;
  rowSpan?: number;
  style?: React.CSSProperties;
}

export const RegularHeaderCell = ({ children, className, rowSpan, style }: React.WithOptionalChildren<Props>) => {
  return (
    <th
      data-testid="matrixHeadCell"
      rowSpan={rowSpan}
      style={style}
      className={cn(
        'h-10 whitespace-nowrap border-2 border-transparent p-0 uppercase text-neutral-60 body-6 lg:min-w-[--matrixCellWidth]',
        className,
      )}
    >
      {children}
    </th>
  );
};
